import { Observer } from 'mobx-react-lite';
import React from 'react';
import joinClassName from '../../utils/className.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import { isNumberLike } from '../../utils/typeChecks.utils';
import './BaseGrid.scss';
export var BaseGrid = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get columns() {
            var input = p.columns;
            var content = '';
            if (input instanceof Array)
                content += input.map(function (n) { return typeof n === 'string' ? n : n + 'fr'; }).join(' ');
            else if (typeof input === 'number')
                content += "repeat(" + input + ", minmax(0, 1fr))";
            else if (typeof input === 'string')
                content += input;
            else
                content += 'minmax(0,1fr)';
            return "[grid-column-start] " + content + " [grid-column-end]";
        },
        get rows() {
            var input = p.rows;
            if (input instanceof Array)
                return input.map(function (n) { return typeof n === 'string' ? n : n + 'fr'; }).join(' ');
            else if (typeof input === 'number')
                return "repeat(" + input + ", minmax(0, 1fr))";
            else if (typeof input === 'string')
                return input;
            return undefined;
        },
        get areas() {
            return p.areas ? p.areas.map(function (r) { return "\"" + r.map(function (c) { return c || '.'; }).join(' ') + "\""; }).join() : undefined;
        },
        get gap() {
            var _a;
            return (_a = p.gap) !== null && _a !== void 0 ? _a : '1em';
        },
        get style() {
            var _a, _b;
            return {
                gridTemplateColumns: s.columns,
                gridTemplateRows: s.rows,
                gridGap: (_a = s.gap) !== null && _a !== void 0 ? _a : '.5em',
                gridTemplateAreas: s.areas,
                alignItems: p.alignItems,
                justifyItems: p.justifyItems,
                '--BaseGridColumnFlexBasisFallback': p.columns ? isNumberLike(p.columns) ? 1 / ((_b = +p.columns) !== null && _b !== void 0 ? _b : 1) * 100 - 5 + '%' : undefined : undefined,
            };
        },
    }); });
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: joinClassName("BaseGrid", p.className), style: s.style, "data-columns": p.columns }, props.children)); } });
};
export default BaseGrid;
